import { setOrderFormError, setOrderFormLoading, clearOrderFormError, reverseGeocodeLocation, updateOrderFormField } from '../redux_files/actions/orderFormActions';
import { PANIPAT_BOUNDS } from './locationConstants';

export const isWithinPanipat = (location) => {
  return (
    location.lat >= PANIPAT_BOUNDS.minLat &&
    location.lat <= PANIPAT_BOUNDS.maxLat &&
    location.lng >= PANIPAT_BOUNDS.minLng &&
    location.lng <= PANIPAT_BOUNDS.maxLng
  );
};

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

export const calculatePrice = (plateSize, numberOfPlates, deliveryDistance, freeRadiusKm = 7) => {
  const plates = numberOfPlates === '' ? 0 : Number(numberOfPlates);
  let platePrice = 0;
  let deliveryCharge = 0;

  if (plateSize === 'half') {
    platePrice = 50;
  } else {
    if (plates > 15) platePrice = 55;
    else if (plates > 6) platePrice = 60;
    else platePrice = 70;
  }

  if (deliveryDistance !== null && deliveryDistance !== undefined) {
    if (deliveryDistance <= freeRadiusKm) {
      deliveryCharge = 0;
    } else if (plates >= 2) {
      deliveryCharge = 0;
    } else if (plates === 1) {
      const chargeableDistance = deliveryDistance - freeRadiusKm;
      deliveryCharge = Math.ceil(chargeableDistance) * 5;
    }
  }

  const subtotal = platePrice * plates;
  const total = subtotal + deliveryCharge;

  return { platePrice, subtotal, deliveryCharge, total, distance: deliveryDistance };
};

export const handleUseCurrentLocation = (dispatch, DELIVERY_CENTER) => {
  if (!navigator.geolocation) {
    dispatch(setOrderFormError('currentLocation', 'Geolocation is not supported by your browser.'));
    return;
  }

  dispatch(setOrderFormLoading(true));
  dispatch(clearOrderFormError('currentLocation'));

  navigator.geolocation.getCurrentPosition((position) => {
    const loc = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };

    if (!isWithinPanipat(loc)) {
      dispatch(setOrderFormLoading(false));
      dispatch(setOrderFormError('currentLocation', 'Your current location is outside the Panipat delivery area.'));
      return;
    }

    const distance = calculateDistance(DELIVERY_CENTER.lat, DELIVERY_CENTER.lng, loc.lat, loc.lng);

    // Dispatch saga action to reverse geocode
    dispatch(reverseGeocodeLocation(loc.lat, loc.lng));

    // Update coordinates and distance
    dispatch(updateOrderFormField('selectedDeliveryCoords', loc));
    dispatch(updateOrderFormField('deliveryDistance', distance));
    dispatch(setOrderFormLoading(false));
  }, (error) => {
    dispatch(setOrderFormLoading(false));

    if (error.code === error.PERMISSION_DENIED) {
      dispatch(setOrderFormError('currentLocation', 'Location permission denied. Please enable location access in your browser settings and try again.'));
    } else if (error.code === error.POSITION_UNAVAILABLE) {
      dispatch(setOrderFormError('currentLocation', 'Location information is unavailable. Please try again or use manual location selection.'));
    } else if (error.code === error.TIMEOUT) {
      dispatch(setOrderFormError('currentLocation', 'Location request timed out. Please try again.'));
    } else {
      dispatch(setOrderFormError('currentLocation', 'Unable to fetch your current location. Please try again.'));
    }
  });
};
